import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { useQuery } from 'react-query'
import { AnimatePresence } from 'framer-motion'
import Loader from 'react-loader-spinner'
import { FeathersContext } from '../../../services/feathers'
import * as s from './Company.styles'
import CreateTalent from './CreateTalentForm/CreateTalentForm'
import { setCompany } from '../../../redux/reducers/talentSlice'
import ErrorPage from '../../../Component/ErrorPage'

const Company = () => {
  const { companyName } = useParams()
  const { company } = useSelector((state) => state.talent)
  const feathers = useContext(FeathersContext)
  const dispatch = useDispatch()
  const { t } = useTranslation(['talentArea'], {
    useSuspense: false,
  })

  const { isFetching } = useQuery({
    queryKey: [companyName],
    useErrorBoundary: (error) => error.response?.status >= 500,
    onError: (e) => console.error(e),
    refetchOnWindowFocus: false,
    enabled: !!companyName,
    queryFn: async () => {
      const response = await feathers.service('lambda-talent').find({
        query: {
          type: 'getCompany',
          companyName,
        },
      })
      return dispatch(setCompany(response))
    },
  })

  if (isFetching) {
    return (
      <s.CompanyWrapper>
        <div className="loader-wrapper">
          <Loader type="TailSpin" color="#2d50e6" height={70} width={70} />
        </div>
      </s.CompanyWrapper>
    )
  }

  if (company?.notFound) {
    return <ErrorPage statusCode={404} />
  }

  return (
    <AnimatePresence exitBeforeEnter>
      <s.CompanyWrapper
        animate={{
          x: 0,
          opacity: 1,
        }}
        initial={{
          x: 300,
          opacity: 0,
        }}
        exit={{
          opacity: 0,
          x: -300,
          transition: { delay: 0.3, duration: 0.5 },
        }}
        transition={{
          stiffness: 75,
          duration: 0.4,
        }}
      >
        <div className="logos-wrapper">
          <img src={company?.logo} height={70} alt="Company logo" />
        </div>
        <h1 className="company-title">
          {t('talentArea:company.title', '{{companyName}} talent community', {
            companyName: company?.name,
          })}
        </h1>
        <p className="company-desc">{company?.description}</p>
        <CreateTalent />
      </s.CompanyWrapper>
    </AnimatePresence>
  )
}

export default Company
